import React from 'react';
import styled from 'styled-components';
import { observer } from 'mobx-react';

interface InputProps {
  title: string;
  maxLength: number;
  onChange: (val: string) => void;
  render?: any;
  value?: string;
}

const YInput = observer((props: InputProps) => {
  const { title, value, maxLength, render = undefined, onChange } = props;

  return (
    <Container>
      <p>{title}</p>
      <input
        type='text'
        value={value || ''}
        autoComplete='off'
        onChange={(e)=> onChange(e.target.value)}
        maxLength={maxLength}
      />
      {render && (<div className="right">{render}</div>)}
    </Container>
  )
})

export default YInput;

const Container = styled.div`
  padding-top: 14px;
  position: relative;
  p {
    font-size: 14px;
    color: #3E3F3F;
    line-height: 19px;
    margin: 0;
    padding-bottom: 5px;
  }

  input {
    border: none;
    border-bottom: 2px solid rgba(208, 214, 230, 0.85);
    outline: none;
    font-size: 18px;
    font-weight: bold;
    color: #464545;
    line-height: 42px;
    width: 100%;
    padding: 0;
    background: transparent;

    &:focus {
      color: #1968FC;
      border-color: #1968FC;
    }
  }

  .right {
    position: absolute;
    right: 0;
    bottom: 0;

    .sent-message {
      font-size: 14px;
      color: #1968FC;
      line-height: 34px;
      cursor: pointer;
      user-select: none;
      &.gray {
        cursor: default;
        color: #D8D8D8;
      }
    }

    img {
      width: 100px;
      height: 35px;
      background: #D8D8D8;
      cursor: pointer;
      display: block;
      margin-bottom: 4px;
    }
  }
`
